import React from 'react';
export function Industries() {
  const industries = ['Retail Stores & Storefronts', 'Shopping Centers & Outlet Malls', 'Restaurants, Bars & Clubs', 'Hotels & Resorts', 'Corporate Offices', 'Professional Centers', 'Medical Offices & Hospitals', 'Schools & Universities', 'Municipal & Government Buildings', 'Churches & Historical Buildings', 'Apartments & Condominiums', 'Auto Dealerships & Service Centers', 'Banks & Financial Institutions', 'Fitness Centers', 'Manufacturing & Industrial Buildings', 'Warehouses & Storage Facilities'];
  return <section className="py-20 bg-white border-t border-slate-200" data-id="element-699" data-mp="1jan6304buw7y">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-700" data-mp="1naxai8ch1ekp">
        <div className="text-center max-w-3xl mx-auto mb-12 anim-on-scroll" data-id="element-701" data-mp="1nd9qwh2kzgvn">
          <h2 className="kosins-heading text-4xl md:text-5xl text-neutral-900 mb-6" data-id="element-702" data-mp="3doxsl1xg9eak">
            Commercial Glass for a Wide Range of Industries
          </h2>
          <p className="text-lg text-slate-600" data-id="element-703" data-mp="5ovx3a7t4jud">
            Kosin’s Glass serves businesses, property owners, builders and
            institutions across many types of commercial spaces.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4" data-id="element-704" data-mp="ffgvoxnhdoda">
          {industries.map((industry, idx) => <div key={idx} className="bg-slate-50 hover:bg-slate-100 border border-slate-200 rounded-lg p-4 text-center transition-colors flex items-center justify-center min-h-[80px] scroll-fade-up" style={{
          animationDelay: `${idx % 4 * 0.05}s`
        }} data-id="element-705" data-mp="ai76nj407epz" data-mpi={idx}>
              <span className="text-slate-700 font-medium text-sm leading-snug" data-id="element-706" data-mp="3nuhcgvh9talp">
                {industry}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}